import styled from 'styled-components';

export const StyledIframe = styled.iframe`
    display: block;
    ${({ $isLoading }) => ($isLoading ? 'opacity: 0;' : 'opacity: 1;')}
    ${({ $canEditChild }) =>
        !$canEditChild &&
        `
        {
            pointer-events: none
        }
    `}
`;

export const SpinnerWrapper = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ theme }) => theme.palette.grayscale.white};
`;
